@if ($product()) {
  <div class="text" itemtype="https://schema.org/Product" itemscope>
    <div class="description">
      <meta itemprop="name" content="{{ $product().label }}" />

      <meta itemprop="description" content="{{ $product().description }}" />
      <link itemprop="image" [href]="$image()" />

      @if ($product().brand) {
        <div itemprop="brand" itemtype="https://schema.org/Brand" itemscope>
          <meta itemprop="name" content="{{ $product().brand }}" />
        </div>
      }

      <h1 class="description-label">{{ $product().label }}</h1>
      <br />
      <div class="description-content">
        <div
          style="white-space: pre-line"
          [innerHTML]="$product().description | safe: 'html'"
        ></div>

        @if ($product().items.length) {
          <div>
            <p>
              <br />
              Ce pack contient : <br />
            </p>

            @for (item of $product().items; track item.id) {
              <div>
                {{ item.qty }} x
                <a
                  [routerLink]="['/', 'location', item.parent?.slug, item.slug]"
                  >{{ item.label }}</a
                >
              </div>
            }
          </div>
        }

        @if ($product().variants.length) {
          <div>
            <p>
              <br />
              Variantes disponibles : <br />
            </p>

            <div>
              @for (
                variant of $product().variants;
                track variant.id;
                let last = $last
              ) {
                <span>
                  <a
                    [routerLink]="[
                      '/',
                      'location',
                      $product().parent?.slug,
                      variant.slug,
                    ]"
                    >{{ getVariant(variant.label) }}</a
                  >
                  @if (!last) {
                    <span>, </span>
                  }
                </span>
              }
            </div>
          </div>
        }
      </div>

      @if (+$product().price !== 0) {
        <div
          class="price"
          itemprop="offers"
          itemtype="https://schema.org/Offer"
          itemscope
        >
          @if ($mode() === "ttc") {
            <div aria-hidden="true" (click)="setMode('ht')">
              @if ($product().real_price !== $product().price) {
                <div class="promo_price">
                  {{ $product().real_price * 1.2 | price: 2 }} TTC
                </div>
              }

              <div>
                <span class="regular_price"
                  >{{ $product().price * 1.2 | price: 2 }} TTC</span
                >

                <fa-icon
                  [icon]="['far', 'circle-question']"
                  title="Tarif jusqu'à 48h de location, ensuite 25% par jour supplémentaire : &#13;&#13;{{
                    ''
                  }}1 jour = {{ $product().price * 1.2 | price: 2 }} TTC &#13;{{
                    ''
                  }}2 jours = {{
                    $product().price * 1.2 | price: 2
                  }} TTC &#13;{{ '' }}3 jours = {{
                    $product().price * 1.2 * 1.25 | price: 2
                  }} TTC &#13;{{ '' }}4 jours = {{
                    $product().price * 1.2 * 1.5 | price: 2
                  }} TTC &#13;{{ '' }}5 jours = {{
                    $product().price * 1.2 * 1.75 | price: 2
                  }} TTC &#13;{{ '' }}6 jours = {{
                    $product().price * 1.2 * 2 | price: 2
                  }} TTC &#13; &#13;{{ '' }}Au delà, nous contacter."
                />
              </div>
            </div>
          }

          @if ($mode() === "ht") {
            <div aria-hidden="true" (click)="setMode('ttc')">
              @if ($product().real_price !== $product().price) {
                <div class="promo_price">
                  {{ $product().real_price | price: 2 }} HT
                </div>
              }

              <div>
                <span class="regular_price"
                  >{{ $product().price | price: 2 }} HT</span
                >

                <fa-icon
                  [icon]="['far', 'circle-question']"
                  title="Tarif jusqu'à 48h de location, ensuite 25% par jour supplémentaire : &#13;&#13;{{
                    ''
                  }}1 jour = {{ $product().price * 1.2 | price: 2 }} TTC &#13;{{
                    ''
                  }}2 jours = {{
                    $product().price * 1.2 | price: 2
                  }} TTC &#13;{{ '' }}3 jours = {{
                    $product().price * 1.2 * 1.25 | price: 2
                  }} TTC &#13;{{ '' }}4 jours = {{
                    $product().price * 1.2 * 1.5 | price: 2
                  }} TTC &#13;{{ '' }}5 jours = {{
                    $product().price * 1.2 * 1.75 | price: 2
                  }} TTC &#13;{{ '' }}6 jours = {{
                    $product().price * 1.2 * 2 | price: 2
                  }} TTC &#13; &#13;{{ '' }}Au delà, nous contacter."
                />
              </div>
            </div>
          }

          <meta
            itemprop="availability"
            content="{{
              $product().status_sell
                ? 'https://schema.org/InStock'
                : 'https://schema.org/OutOfStock'
            }}"
          />
          <meta itemprop="priceCurrency" content="EUR" />
          <meta itemprop="price" content="{{ $product().price * 1.2 }}" />
          <meta
            itemprop="businessFunction"
            content="http://purl.org/goodrelations/v1#LeaseOut"
          />
        </div>
      }

      @if (+$product().price === 0 && !$product().variants.length) {
        <div class="no-price">
          <div>Tarif sur devis</div>
        </div>
      }

      <!-- <div *ngFor="let price of $product().prices" >
          <span *ngIf="price.regular" [class]="price.promo ? 'regular_price' : ''">{{ price.regular }}<span *ngIf="!isNaN(+price.regular)">€</span></span><span *ngIf="price.promo" class="promo_price">{{ price.promo }}<span *ngIf="!isNaN(+price.regular)">€</span></span><span *ngIf="price.item"> / {{ price.item }}</span>
        </div>
        <br>
        <div *ngIf="$product().extra">
          <br><div [innerHTML]="$product().extra"></div>
          <br class="hide-s">
        </div> -->

      <div class="call-to-action">
        @if ($product().status_sell && !$product().variants?.length) {
          <button [routerLink]="['/contact']" class="link">
            <fa-icon [icon]="['fas', 'calendar-alt']"></fa-icon
            >&nbsp;&nbsp;Réserver
          </button>
        }

        @if (!$product().status_sell && $product().status_buy) {
          <button class="no-link">
            <div
              style="color: var(--color-tertiary); mix-blend-mode: difference"
            >
              <fa-icon [icon]="['far', 'calendar']"></fa-icon
              >&nbsp;&nbsp;Disponible prochainement
            </div>
          </button>
        }

        @if (!$product().status_sell && !$product().status_buy) {
          <button class="no-link">
            <div
              style="color: var(--color-tertiary); mix-blend-mode: difference"
            >
              <fa-icon [icon]="['fas', 'calendar-times']"></fa-icon
              >&nbsp;&nbsp;Le produit n'est actuellement pas disponible
            </div>
          </button>
        }
      </div>
    </div>
  </div>

  <div class="media">
    <div>
      <div class="gallery">
        <!-- <img [attr.src]="$product().documents && $product().documents[0] ? $product().documents[0].src : '' | safeUrl"> -->
        <audio-gallery
          [sources]="$slides()"
          [title]="'Retrouvez en location : ' + $product().label"
        ></audio-gallery>
      </div>

      <ul class="resources">
        @for (pdf of $pdfs(); track pdf.src) {
          <li>
            <a
              [attr.href]="
                environment.apiUrl + pdf.src + '.pdf' | safe: 'resourceUrl'
              "
              target="blank"
              >{{ pdf.filename + ".pdf" }}</a
            >
          </li>
        }
      </ul>
    </div>
  </div>
}
